import { useInjectSaga } from 'Utils/ReduxInjectors';
import { sliceKey as SRISliceKey } from 'Slice/SRISlice';
import { SRISaga } from 'Saga/SRISaga';

const SRIRouteInjector = function SRIRouteInjector() {
  useInjectSaga({ key: SRISliceKey, saga: SRISaga });
  return null;
};

export default SRIRouteInjector;
